var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"w-100",attrs:{"src":"https://socialchat.tubtimcrm.com","frameborder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }